import React, { Component } from 'react'
import _ from 'lodash'
import { withRouter } from 'react-router-dom'
import queryString from 'query-string'
import PQueue from '../vendor/p-queue'
import I18n from '../lib/i18n'
import withTracker from '../lib/withTracker'
import withStore from '../lib/withStore'
import withHeader from '../lib/withHeader'
import formatCurrency from '../helpers/formatCurrency'
import SpinnerWithOverlay from '../components/SpinnerWithOverlay'
import PageMiddleSpinner from '../components/PageMiddleSpinner'
import CartItem from '../components/CartItem'
import Modal from '../components/Modal'
import PaymentOptionsBottomSheet from '../components/PaymentOptionsBottomSheet'
import InfoForm from '../components/InfoForm'
import EmptyPageContainer from '../components/EmptyPageContainer'
import Config from '../configs'
import * as StyledComponent from '../styles'
import * as API from '../api'
import { isAlipayBrowser, isWeChatBrowser } from '../helpers/detectBrowser'
import * as ScrollViewControl from '../lib/scrollViewControl'

class Cart extends Component {
  constructor(props) {
    super(props)

    this._modal = null
    this.apple_pay_session = null
    this._payment_sheet = React.createRef()
    this.state = {
      skus_data: [],
      is_payment_options_list_open: false,
      modal_props: {},
      loading_items: false,
      is_item_fetched: false,
      checkout_loading: false,
      fields: {
        staff_number: ''
      },
      inline_errors: {},
      error_exist: false,
      order_id: this.getHashParams('order_id'),
      payment_provider_id: this.getHashParams('payment_provider_id')
    }
    // load cart skus details queue
    this.load_skus_details_queue = new PQueue({ concurrency: 2 })
  }

  componentDidMount() {
    this.fetchItems()
    // display a generic error message if error_message exist on params
    if (this.getParams('error_message')) {
      this.removeErrorCodeFromParam()
      this.handleError({})
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.getHashParams('checkout')) {
      if (!prevProps.store.is_info_form_open) {
        this.toggleInfoForm(true)
      }
    } else {
      if (!!prevProps.store.is_info_form_open) {
        this.toggleInfoForm(false)
      }
    }
  }

  removeErrorCodeFromParam = () => {
    const query = queryString.parse(window.location.search)
    const new_query = queryString.stringify(_.pick(query, 'slug'))

    window.history.pushState({}, '', `${window.location.origin}?${new_query}${window.location.hash}`)
  }

  calculateTotalQuantityAndPrice = () => {
    let total_price = 0
    let total_quantity = 0

    _.map(this.state.skus_data, (sku, index) => {
      const { sell_price = '' } = sku

      total_quantity = total_quantity + sku.quantity
      total_price = total_price + sell_price * sku.quantity
    })

    return { total_quantity, total_price }
  }

  fetchItems = async () => {
    try {
      this.setState({ loading_items: true })

      const databin_data = await API.fetchDatabin()
      const shopping_cart_items = _.get(databin_data, 'data.data_bin.data.shopping_cart_items', [])

      // finish loading if no items on databin
      if (_.isEmpty(shopping_cart_items)) {
        this.setState({ loading_items: false, is_item_fetched: true })
        return
      }

      const sku_ids = _.map(shopping_cart_items, (shopping_cart_item, index) => {
        return shopping_cart_item.sku_id
      })

      // get total page needed to fetch with a page_size of 50
      const total_pages = _.ceil(sku_ids.length / Config.get('FETCH_SKU_PAGE_SIZE'))

      let all_skus_data = []
      let error

      const skus_details_fetch = _.map(_.range(total_pages), (index) => {
        const page = index + 1

        return () => API.fetchSkusDetails(sku_ids, page).then(res => {
          const pagination = _.get(res, 'data.skus_pagination')
          // clear the queue if reached last page
          if (pagination.is_last_page) {
            this.load_skus_details_queue.clear()
          }

          const new_skus_data = _.map(res.data.skus, (shopping_cart_item, index) => {
            const shopping_cart_item_data = _.find(shopping_cart_items, { sku_id: shopping_cart_item.id }) || {}
            const quantity = shopping_cart_item_data.quantity || 1

            return { ...this.getNeededItemData(shopping_cart_item), quantity }
          })
          all_skus_data = all_skus_data.concat(new_skus_data)
        })
      })

      this.load_skus_details_queue.addAll(skus_details_fetch).catch(err => { error = err })

      await this.load_skus_details_queue.onIdle()

      if (error) {
        throw error
      }

      this.setState({ skus_data: all_skus_data, loading_items: false, is_item_fetched: true }, () => {
        // update the quantity in shopping bag icon
        this.updateShoppingBagIcon()
      })
    }
    catch(err) {
      this.handleError(err)
      this.setState({ error_exist: true, loading_items: false })
    }
  }

  getNeededItemData = sku => {
    const { id, product = {}, color_option = {}, size_option = {}, sell_price = '', stock_level } = sku
    const { title = '', hide_variants = [] } = product
    const hide_color_option = _.includes(hide_variants, 'color_option')
    const hide_size_option = _.includes(hide_variants, 'size_option')
    const { swatch = '', hex_value = '', name: color_name = '' } = color_option
    const versions = _.get(color_option, 'default_image.versions', {})
    const { name: size_name = '' } = size_option
    // CP20180523: API team say should not use SPECIAL_PRICE_LABEL here are already have sku price!!!
    // const sell_price = _.get(color_option, Config.get('SPECIAL_PRICE_LABEL'))
    //   || _.get(product, Config.get('SPECIAL_PRICE_LABEL'))
    //   || _.get(item, 'sell_price')

    return {
      id,
      image: versions.mobile_medium,
      title,
      hex_value,
      swatch,
      color_name,
      size_name,
      sell_price,
      hide_color_option,
      hide_size_option,
      stock_level
    }
  }

  getHashParams = (key) => {
    const params = new URLSearchParams(this.props.location.search)

    return params.get(key)
  }

  getParams = (key) => {
    const params = new URLSearchParams(window.location.search)

    return params.get(key)
  }

  handleChangeQuantity = async (sku_id, quantity) => {
    const new_skus_data = _.cloneDeep(this.state.skus_data)
    let target_sku = _.find(new_skus_data, { id: sku_id })
    target_sku.quantity = quantity

    // update Databin
    const databin_upload_data = {
      shopping_cart_items: new_skus_data.map(sku => {
          return { sku_id: sku.id, quantity: sku.quantity }
        })
    }

    try {
      await API.updateDatabin(databin_upload_data)
      this.setState({ skus_data: new_skus_data })
      // reset inline error when the sku is changing quantity
      this.removeInlineErrorMsg(sku_id)
      // update the quantity in shopping bag icon
      this.updateShoppingBagIcon()
    } catch(err) {
      this.handleError(err)
    }
  }

  handleRemoveItem = async (sku_id) => {
    const new_skus_data = _.cloneDeep(this.state.skus_data)
    _.remove(new_skus_data, (sku, i) => sku.id === sku_id)
    // update Databin
    const databin_upload_data = {
      shopping_cart_items: new_skus_data.map(sku => {
          return { sku_id: sku.id, quantity: sku.quantity }
        })
    }

    this.removeInlineErrorMsg(sku_id)

    try {
      await API.updateDatabin(databin_upload_data)
      this.setState({ skus_data: new_skus_data })
      // update the quantity in shopping bag icon
      this.updateShoppingBagIcon()
    } catch(err) {
      this.handleError(err)
    }
  }

  handlePlaceOrder = () => {
    if (this.state.skus_data.length > this.props.store.system_settings['shopping_cart.item.max_sku_per_order.cdb']) {
      this.setModalProps({
        title: I18n.t('containers.cart.notice_title'),
        body: I18n.t('errors.max_items_reached'),
        buttons: [
          {
            onClick: () => this._modal.close(),
            text: I18n.t('containers.cart.dismiss')
          }
        ]
      })

      this._modal.open()
      return
    }

    this.props.history.push(`/${I18n.currentLocale()}/?checkout=true`)
  }

  handleInfoFormSubmit = (data) => {
    this.props.history.push(`/${I18n.currentLocale()}/`)

    if (data.errors) {
      this.handleError(data)
      return
    }

    this.toggleCheckoutLoading(true, () => this.checkout(data))
  }

  handleError = (err) => {
    const error = API.handleError(err)
    const { error_message, inline_errors, code } = error

    if (!_.isEmpty(inline_errors)) {
      _.each(inline_errors, (value, key) => {
        this.setInlineErrorMsg(key, value)
      })
      return
    }

    if (error.code === 30101) {
      this.setModalProps({
        title: I18n.t('containers.cart.notice_title'),
        body: I18n.t('errors.exceed_daily_order_limit'),
        buttons: [
          {
            onClick: () => this._modal.close(),
            text: I18n.t('containers.cart.dismiss')
          }
        ]
      })

      this._modal.open()
      return
    }

    this.saveToStore({ alert_message: error_message }, () => this.props.store.flash.open())
  }

  browseProductGroups = () => {
    this.props.history.push(`/${I18n.currentLocale()}/products`)
  }

  updateShoppingBagIcon = () => {
    // update the icon quantity
    const { total_quantity } = this.calculateTotalQuantityAndPrice()
    this.saveToStore({ cart_total_items: total_quantity })
  }

  handleFieldChange = (e) => {
    const { name, value } = e.target
    this.setState({
      fields: {
        [name]: value
      }
    })
  }

  togglePaymentOptionsList = (open) => {
    this.handleToggleBottomSheet(open)
    this.setState({ is_payment_options_list_open: open })
  }

  toggleInfoForm = (open) => {
    this.handleToggleBottomSheet(open)
    this.saveToStore({ is_info_form_open: open })
  }

  handleToggleBottomSheet = (open) => {
    open
      ? ScrollViewControl.preventScrolling()
      : ScrollViewControl.allowScrolling()
  }

  setInlineErrorMsg = (sku, err_msg) => {
    this.setState({
      inline_errors: {
        ...this.state.inline_errors,
        [sku]: err_msg
      }
    })
  }

  removeInlineErrorMsg = (sku) => {
    this.setState({
      inline_errors: {
        ..._.omit(this.state.inline_errors, sku)
      }
    })
  }

  checkout = async (customer_info) => {
    try {
      const order_res = await this.createOrder(customer_info)
      const { order } = order_res.data
      const { available_payment_providers } = order
      const alipay = _.find(available_payment_providers, { payment_provider_internal_code: 'ALIPAY_H5_MAINLAND' })
      const alipayHK = _.find(available_payment_providers, { payment_provider_internal_code: 'ALIPAY_H5_WAP_MAINLAND_HK' })
      const wechatpay = _.find(available_payment_providers, { payment_provider_internal_code: 'WECHAT_H5_MAINLAND_HK' })
      // deferred payment option is missing in api, add here manually
      if (order.can_defer_payment) {
        available_payment_providers.push({
          payment_provider_internal_code: 'deferred',
          name: I18n.t('containers.cart.deferred_payment'),
          icon_data_uri: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDMyIDI0Ij4KICAgIDxnIGZpbGw9IiMwMDAiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgPHBhdGggZD0iTTIgMWExIDEgMCAwIDAtMSAxdjIwYTEgMSAwIDAgMCAxIDFoMjhhMSAxIDAgMCAwIDEtMVYyYTEgMSAwIDAgMC0xLTFIMnptMC0xaDI4YTIgMiAwIDAgMSAyIDJ2MjBhMiAyIDAgMCAxLTIgMkgyYTIgMiAwIDAgMS0yLTJWMmEyIDIgMCAwIDEgMi0yeiIvPgogICAgICAgIDxjaXJjbGUgY3g9IjExIiBjeT0iMTIiIHI9IjEiLz4KICAgICAgICA8Y2lyY2xlIGN4PSIxNiIgY3k9IjEyIiByPSIxIi8+CiAgICAgICAgPGNpcmNsZSBjeD0iMjEiIGN5PSIxMiIgcj0iMSIvPgogICAgPC9nPgo8L3N2Zz4K'
        })
      }
      // save available payment providers to store
      this.saveToStore({ available_payment_providers, order })

      if (isAlipayBrowser()) {
        this._payment_sheet.current.handleSelectPayment(alipayHK)
        return
      }

      if (isWeChatBrowser()) {
        this._payment_sheet.current.handleSelectPayment(wechatpay)
        return
      }
      this.togglePaymentOptionsList(true)
    } catch(err) {
      this.handleError(err)
    } finally {
      this.toggleCheckoutLoading(false)
    }
  }

  createOrder = (customer_info) => {
    this.setState({})
    const { total_price } = this.calculateTotalQuantityAndPrice()

    return API.createOrder(customer_info, total_price)
  }

  toggleCheckoutLoading = (checkout_loading, cb) => {
    this.setState({ checkout_loading }, cb)
  }

  setModalProps = (modal_props) => {
    this.setState({ modal_props })
  }

  setPICSModalProps = () => {
    this.setModalProps({
      title: I18n.t('containers.info_form.pics_title'),
      body: <StyledComponent.PICSModal>{I18n.t('containers.info_form.pics')}</StyledComponent.PICSModal>,
      buttons: [
        {
          onClick: () => this._modal.close(),
          text: I18n.t('containers.cart.dismiss')
        }
      ]
    })
  }


  saveToStore = (state, cb) => {
    this.props.store.save(state, cb)
  }

  render() {
    const {
      skus_data,
      loading_items,
      add_to_bag_loading,
      checkout_loading,
      inline_errors,
      error_exist,
      is_payment_options_list_open,
      is_item_fetched,
      modal_props,
      order_id,
      payment_provider_id
    } = this.state
    const { system_settings = {} } = this.props.store
    const { total_quantity, total_price } = this.calculateTotalQuantityAndPrice()
    const cart_items = _.map(skus_data, (sku, index) => {
      const error = inline_errors[sku.id]

      return <CartItem
        key={`cart-item-${index}`}
        setInlineErrorMsg={this.setInlineErrorMsg}
        onQuantityChange={this.handleChangeQuantity}
        max_qty={system_settings['shopping_cart.item.max_qty_per_sku.cdb']}
        removeItem={this.handleRemoveItem}
        sku_data={sku}
        error={error}
      />
    })
    // const bag_fee = Config.get('BAG_FEE')
    // const bag_fee_threshold = Config.get('BAG_FEE_THRESOLD')

    // if (total_price >= bag_fee_threshold) {
    //   total_price = total_price + bag_fee
    // }
    if (error_exist) {
      return <EmptyPageContainer
        message={I18n.t('containers.cart.load_error')}
        buttons={[{
          onClick: () => window.location.reload(),
          text: I18n.t('containers.cart.reload_btn')
        }]}
      />
    }
    if (_.isEmpty(cart_items) && !loading_items && is_item_fetched) {
      return <EmptyPageContainer
        message={I18n.t('containers.cart.empty_message')}
        buttons={[{
          onClick: this.browseProductGroups,
          text: I18n.t('containers.cart.shop_now')
        }]} />
    }
    return <StyledComponent.PageContainer id='scroll-view'>
      <StyledComponent.Cart>
        {
          this.props.store.is_info_form_open
            ? <InfoForm
                open={!!this.props.store.is_info_form_open}
                onClose={this.toggleInfoForm.bind(this, false)}
                onSubmit={this.handleInfoFormSubmit}
                setPICSModalProps={this.setPICSModalProps}
                onOpenPICS={() => this._modal.open()}
              />
            : loading_items
                ? <PageMiddleSpinner loading={true} />
                : <React.Fragment>
                    <div className='items-list'>
                      { cart_items }
                      {
                        // total_price > 680 &&
                        // <div className='bag-charge_message'>
                        //   {I18n.t('containers.cart.bag_charge_message', { fee: 1 })}
                        // </div>
                      }
                    </div>
                    <RenderCartFooter
                      quantity={total_quantity}
                      total_price={total_price}
                      disabled={!_.isEmpty(inline_errors)}
                      onClick={this.handlePlaceOrder}
                    />
                  </React.Fragment>
        }
        <SpinnerWithOverlay loading={add_to_bag_loading || checkout_loading} />
      </StyledComponent.Cart>
      <Modal ref={ref => this._modal = ref} {...modal_props} />
      <PaymentOptionsBottomSheet
        store={this.props.store}
        ref={this._payment_sheet}
        open={is_payment_options_list_open}
        onClose={this.togglePaymentOptionsList.bind(this, false)}
        togglePaymentOptionsList={this.togglePaymentOptionsList}
        toggleCheckoutLoading={this.toggleCheckoutLoading}
        setModalProps={this.setModalProps}
        confirm_modal={this._modal}
        order_id={order_id}
        payment_provider_id={payment_provider_id}
        router_history={this.props.history}
      />
    </StyledComponent.PageContainer>
  }
}

const RenderCartFooter = (props) =>
  <div className='cart-footer-container'>
    <div className='subtotal-container'>
      <div className='item-count'>
        <span className='label'>{I18n.t('containers.cart.subtotal')}</span>
        <span className='count'>
          {I18n.t('containers.cart.items', { count: props.quantity })}
        </span>
      </div>
      <div className='total-price'>HK{formatCurrency(props.total_price)}</div>
    </div>
    <div className='btn-container'>
      <button className='place-order-btn' onClick={props.onClick} disabled={props.disabled}>
        {I18n.t('containers.cart.place_order_button')}
      </button>
    </div>
  </div>

export default withTracker(withStore(withRouter(withHeader(Cart))), {
  title: I18n.t('containers.cart.title')
})



// WEBPACK FOOTER //
// ./src/containers/Cart.js